if (!customElements.get('page-controller')) {
	class Pagination extends HTMLElement {
		constructor() {
			super();
			if (!this.classList.contains('pagination_type--load-more')) return;
			this.productGrid = document.querySelector('#main-collection-product-grid');
			if (this.dataset.currentPage) this.currentPage = parseInt(this.dataset.currentPage);
			if (this.dataset.pagesLimit) this.pagesLimit = parseInt(this.dataset.pagesLimit);
			if (this.productGrid) this.addEventListener('click', this.loadMore)
		}

		async loadMore(ev) {
			ev.preventDefault();
			if (!this.currentPage) return;
			const target = ev.target;
			this.currentPage = this.currentPage + 1;
			if (this.pagesLimit == this.currentPage) target.remove();
			target.classList.add('loading');
			const searchPage = document.querySelector('[search-page]');
			let url;
			if (searchPage) {
				const urlParams = new URLSearchParams(window.location.search);
				const searchVal = urlParams.get('q');
				if (!searchVal) return;
				url = document.location.pathname + `?q=${searchVal}&page=${this.currentPage}`;
			}
			else url = document.location.pathname + `?page=${this.currentPage}`;

			const fetchedProducts = await fetch(url);
			if (fetchedProducts.status !== 200 || fetchedProducts.ok !== true) {
				throw new Error('Network response was not ok, while loading new products');
			}
			const fetchedProductsRaw = await fetchedProducts.text();
			if (!fetchedProductsRaw) return;
			this.renderProducts(fetchedProductsRaw, target);
		}

		renderProducts(fetchedProductsRaw, target) {
			const parsedHtml = new DOMParser().parseFromString(fetchedProductsRaw, 'text/html');
			if (!parsedHtml) return;
			const productGrid = parsedHtml.querySelector('#main-collection-product-grid');
			if (!productGrid) return;
			const productItems = productGrid.querySelectorAll('.product-item');
			if (!productItems) return;
			for (const productItem of productItems) {
				this.productGrid.appendChild(productItem);
			}
			target.classList.remove('loading');
		}
	}
	customElements.define('page-controller', Pagination);

}